import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Row,
  Col,
  Table,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
} from "reactstrap";
import { withRouter } from "react-router-dom";
import moment from "moment";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import TableScrollbar from "react-table-scrollbar";
import DefaultImg from "../../assets/images/product/Default_img.jpg";
import {
  getAuditRFQRowData,
  AuditPopRight,
} from "../../store/Audit_Report/actions";

class QuotationCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      isAlertOpen: false,
      selectedItems: {},
      maximize: true,
    };
  }

  maximizetogle() {
    this.setState((prevState) => ({
      maximize: !prevState.maximize,
    }));
  }
  callNextCard(id) {
    if (this.props.AuditData.length - 1 === this.props.index) {
      this.props.getAuditRFQRowData({
        ScreenID: id,
      });
      this.setState((prevState) => ({
        maximize: !prevState.maximize,
      }));
    }
  }
  render() {
    var obj = {};
    obj = this.props.obj;
    return (
      <div className={this.state.maximize ? "maximize" : "minimize"}>
        <>
          <Row className="plaseholder">
            <Col md={12} className="p-1 W-100">
              <Card className="p-0 ">
                <CardHeader className="bg-transparent border-bottom ">
                  <h5 className="card-title-18 pt-2 d-inline-block">
                    Quotation ({obj.data.code})
                  </h5>
                  {/* <span>
                    <Link
                      onClick={() => {
                        this.maximizetogle();
                      }}
                      className="action-icon text-primary mr-2"
                    >
                      <i className="mdi mdi-alpha-e-box-outline font-size-20"></i>
                    </Link>
                  </span> */}
                </CardHeader>
                <CardBody className="p-2 ">
                  <Row>
                    <Col md={6}>
                      <div>
                        <ul className="list-style-two p-0 ml-4  ">
                          <li className="clearfix">
                            <span className="ttl">RFQ No:</span>
                            <span className="dtl">
                              {obj.data.requestforquotation_code}
                            </span>
                          </li>
                          <li className="clearfix">
                            <span className="ttl">RFQ Date:</span>
                            <span className="dtl">
                              {moment(obj.data.requestforquotation_date).format(
                                "DD-MM-YYYY"
                              )}
                            </span>
                          </li>
                          <li className="clearfix">
                            <span className="ttl">Vendor Name:</span>
                            <span className="dtl">{obj.data.vendor?.name}</span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div>
                        <ul className="list-style-two p-0 ml-4  ">
                          <li className="clearfix">
                            <span className="ttl">Total Price:</span>
                            <span className="dtl">{obj.data.total}</span>
                          </li>
                          <li className="clearfix">
                            <span className="ttl">Delivery Date:</span>
                            <span className="dtl">{obj.data.deliverydate}</span>
                          </li>
                        </ul>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} className="m-1">
                      <Card className="pt-1">
                        <CardBody className="p-0">
                          <div className="table-responsive m-1">
                            <TableScrollbar height="400px">
                              <Table className="mb-0 p-1">
                                <thead className="bg-light text-center">
                                  <tr>
                                    <th className="nowrap">S.No</th>
                                    <th className="nowrap">Item Images</th>
                                    <th style={{ minWidth: "220px" }}>
                                      Item Name
                                    </th>
                                    <th className="nowrap">Quantity</th>
                                    <th className="nowrap">Item Base Price</th>
                                    <th className="nowrap">Item Discount(%)</th>
                                    <th className="nowrap">Item Price</th>
                                    <th className="nowrap">Tax Type</th>
                                    <th className="nowrap">Tax (%)</th>
                                    <th className="nowrap">Gross Value</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {obj.data.qitems?.map((item, key) => (
                                    <tr key={key}>
                                      <td className="nowrap text-center">
                                        {key + 1}
                                      </td>
                                      <td className="nowrap text-center">
                                        <div className="product-detail text-center">
                                          <img
                                            src={
                                              item?.product?.image == null
                                                ? DefaultImg
                                                : item?.product?.image
                                            }
                                            alt="product-img"
                                            title="product-img"
                                            className="product-img  img-fluid mx-auto tab-img rounded"
                                            style={{
                                              height: "100px",
                                              width: "150px",
                                            }}
                                          />
                                        </div>
                                      </td>
                                      <td>
                                        <h5 className="font-size-14">
                                          <Link
                                            to="#"
                                            onClick={() =>
                                              this.callNextCard(
                                                obj.data.requestforquotation
                                              )
                                            }
                                            className="text-primary"
                                          >
                                            <u>{item.product.name}</u>
                                          </Link>
                                        </h5>
                                        <p className="mb-0">
                                          <b className="text-dark">Make :</b>{" "}
                                          <span className="font-weight-medium">
                                            {item.make}
                                          </span>
                                        </p>

                                        <p>
                                          {" "}
                                          <b className="text-dark">
                                            Quantity :
                                          </b>{" "}
                                          <span className="font-weight-medium">
                                            {item.originalqty} {item.unit.name}
                                          </span>
                                        </p>
                                      </td>
                                      <td className=" text-center">
                                        {item.qty} {item.unit.name}
                                      </td>
                                      <td
                                        className="text-center"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <InputGroup>
                                          <Input
                                            placeholder="Item Base Price"
                                            min={0}
                                            type="number"
                                            id="baseprice"
                                            value={item.baseprice}
                                          />
                                          <InputGroupAddon addonType="append">
                                            <InputGroupText>
                                              &#8377;
                                            </InputGroupText>
                                          </InputGroupAddon>
                                        </InputGroup>
                                      </td>
                                      <td
                                        className="text-center"
                                        style={{
                                          minWidth: "120px",
                                        }}
                                      >
                                        <InputGroup>
                                          <Input
                                            placeholder="Item discountpercent"
                                            min={0}
                                            type="number"
                                            id="baseprice"
                                            value={item.discountpercent}
                                          />
                                          <InputGroupAddon addonType="append">
                                            <InputGroupText>%</InputGroupText>
                                          </InputGroupAddon>
                                        </InputGroup>
                                      </td>
                                      <td
                                        className="text-center"
                                        style={{
                                          minWidth: "150px",
                                        }}
                                      >
                                        <InputGroup>
                                          <Input
                                            placeholder="Item Price"
                                            min={0}
                                            type="number"
                                            id="price"
                                            value={item.price}
                                            readOnly
                                            disabled={true}
                                          />
                                          <InputGroupAddon addonType="append">
                                            <InputGroupText>
                                              &#8377;
                                            </InputGroupText>
                                          </InputGroupAddon>
                                        </InputGroup>

                                        <p>
                                          Item Discount: &#8377; {item.discount}
                                        </p>
                                      </td>
                                      <td className=" text-center">
                                        <div>
                                          <FormGroup className="mb-0">
                                            <Input
                                              type="text"
                                              className="form-control"
                                              placeholder="Taxtype"
                                              value={
                                                parseInt(item.taxtype) === 1
                                                  ? "Inclusive"
                                                  : "Exclusive"
                                              }
                                              // value={item.taxtype}
                                              readOnly
                                              disabled={true}
                                            />
                                          </FormGroup>{" "}
                                        </div>
                                      </td>
                                      <td className="nowrap text-center">
                                        <div>
                                          <FormGroup className="mb-0">
                                            <Input
                                              type="text"
                                              className="form-control"
                                              placeholder="Taxtype"
                                              value={item.tax.name}
                                              readOnly
                                              disabled={true}
                                            />
                                          </FormGroup>{" "}
                                          <p>
                                            Tax Amount: &#8377; {item.taxamount}
                                          </p>
                                        </div>
                                      </td>
                                      <td className="nowrap">
                                        <div>
                                          <InputGroup>
                                            <Input
                                              type="number"
                                              className="form-control"
                                              placeholder="Gross Value"
                                              value={item.gross}
                                              readOnly
                                              disabled={true}
                                            />
                                            <InputGroupAddon addonType="append">
                                              <InputGroupText>
                                                &#8377;
                                              </InputGroupText>
                                            </InputGroupAddon>
                                          </InputGroup>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </TableScrollbar>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <Card className="p-0 ">
                        <CardHeader className="bg-transparent border-bottom p-1 ">
                          <i className="mdi mdi-alert-outline ml-2 mr-2 font-size-20"></i>

                          <h5 className="card-title-15 d-inline-block">
                            Terms & Conditions
                          </h5>
                        </CardHeader>
                        <CardBody className="p-2 ">
                          <div>
                            <FormGroup className="mb-0">
                              <Input
                                type="textarea"
                                className="form-control"
                                placeholder="Enter Terms & Conditions"
                                rows="7"
                                disabled={true}
                                value={obj.data.terms}
                              />
                            </FormGroup>{" "}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                    <Col md={6}>
                      <Card className="p-0 ">
                        <CardHeader className="bg-transparent border-bottom p-1">
                          <i className="mdi mdi-alert-circle-outline ml-2 mr-2 font-size-20"></i>

                          <h5 className="card-title-15 d-inline-block">
                            Other Details
                          </h5>
                        </CardHeader>
                        <CardBody className="p-2 ">
                          <div>
                            <FormGroup className="mb-0">
                              <Input
                                type="textarea"
                                className="form-control"
                                placeholder="Enter Details"
                                // maxLength="225"
                                rows="7"
                                disabled={true}
                                value={obj.data.description}
                              />
                            </FormGroup>{" "}
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>

                  {/* <CardFooter className="bg-transparent p-1">
                        <div className="float-right">
                          <Button
                            type="reset"
                            color="light"
                            className="waves-effect waves-light mr-2"
                            href="/quotationdashboard"
                          >
                            Back
                          </Button>
                         
                        </div>
                      </CardFooter> */}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Link
            to="#"
            className="strip"
            onClick={() => {
              this.maximizetogle();
              this.props.AuditPopRight(this.props.index);
            }}
          >
            <div className="MaximizeCard-item mb-2 ">
              <div className="MaximizeCard-title-box d-inline-block">
                <span className="mt-4">Quotation ({obj.data.code})</span>
              </div>
            </div>
          </Link>
        </>
      </div>
    );
  }
}

const mapStatetoProps = (state) => {
  const { AuditData } = state.AuditReport;
  return {
    AuditData,
  };
};

export default withRouter(
  connect(mapStatetoProps, {
    getAuditRFQRowData,
    AuditPopRight,
  })(QuotationCard)
);
